var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.97 5.407v.507m0 12.975V9.056m12.059 9.833v-5.876a4.296 4.296 0 0 0-4.289-4.288 4.296 4.296 0 0 0-4.296 4.288m0 0v5.876m0-5.876V9.056M5.824 23h12.353A4.823 4.823 0 0 0 23 18.177V5.823A4.823 4.823 0 0 0 18.177 1H5.823A4.823 4.823 0 0 0 1 5.823v12.354A4.823 4.823 0 0 0 5.823 23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLine);
export default __webpack_public_path__ + "static/media/linkedin_line.e2004033821f33ecead327b3cd80ce47.svg";
export { ForwardRef as ReactComponent };